import React, { useState } from 'react'
import Layout from '../../../layout'
import { makeStyles } from "@material-ui/core";
import Register from './register';
import WhyBourse from './whyBourse';
import Cart from './cart';
import SellAndBuy from './sellAndBuy';
import CashDesk from './cashDesk';
import Faq from './faq';
import HelpCustomer from './helpCustomer';
import Supporttext from './Supporttext/index';


const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        minHeight: 1300
    },

    wrapper: {
        // position: 'absolute',
        position: 'relative',
        width: '100%',
        height:'auto',
        top: 0,
    },

}))


export default function Home() {

    const classes = useStyles()

    return (
        <Layout >
            <div className={classes.root} >
              <Register />
              <WhyBourse />
              <SellAndBuy />
              <Cart />
              <CashDesk />
              <Faq />
              <HelpCustomer />
              <Supporttext />
            </div>
        </Layout >
    )
}
